import { DefaultTheme } from "styled-components";
import { aqmedTheme } from "./aqmed/theme.aqmed";
import { ararasTheme } from "./araras/theme.araras";
import { bambinoTheme } from "./bambino/theme.bambino";
import { cejamTheme } from "./cejam/theme.cejam";
import amplimedTheme from "./default";
import { vitatTheme } from "./vitat/theme.vitat";
import { qualiredeTheme } from "./qualirede/theme.qualirede";

const getTheme = (theme: string): DefaultTheme => {
  switch (theme) {
    case "vitat":
      return vitatTheme;
    case "aqmed":
      return aqmedTheme;
    case "araras":
      return ararasTheme;
    case "bambino":
      return bambinoTheme;
    case "cejam":
      return cejamTheme;
    case "qualirede":
      return qualiredeTheme;
    default:
      return amplimedTheme;
  }
};

export default getTheme;
